import axios from "axios";
import dayjs from "dayjs";
import { VERSION_BUCKET_URL } from "./constants";

export const roundToTwo = (num: number): number => {
  return Math.round(num * 100) / 100;
};

export const countVars = (body: string): string[] => {
  const matches = body.match(/{{\s*(\d+)\s*}}/g);
  if (!matches) return [];
  return matches.map((m) => m.match(/\d+/)?.[0] || "").filter((rec) => rec);
};

export const chatDateFormatter = (dateString: string): string => {
  const date = dayjs(dateString);
  const now = dayjs();
  if (date.isSame(now, "day")) {
    return "Today";
  } else if (date.isSame(now.subtract(1, "day"), "day")) {
    return "Yesterday";
  } else if (date.isAfter(now.subtract(7, "day"))) {
    return date.format("dddd");
  } else {
    return date.format("MMM DD, YYYY");
  }
};

export const getCurrencySymbol = (currencyCode: string): string => {
  currencyCode = currencyCode.toUpperCase();
  const currencySymbols: Record<string, string> = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    SAR: "﷼",
    // Add more currency codes and their symbols as needed
  };
  return currencySymbols[currencyCode] || currencyCode;
};

export async function getLatestVersion() {
  try {
    const res = await axios.get(VERSION_BUCKET_URL, {
      params: {
        t: Date.now(), // Cache busting parameter
      },
    });
    return res.data.trim();
  } catch {
    return "";
  }
}

export const formatDuration = (
  totalHours: number | null | undefined,
  t?: (key: string) => string,
): string => {
  if (totalHours == null) return "-";
  const days = Math.floor(totalHours / 24);
  const hours = Math.round((totalHours % 24) * 100) / 100;
  const dLabel = t ? t("common.days") : "d";
  const hLabel = t ? t("common.hours") : "h";
  if (days > 0 && hours > 0) return `${days} ${dLabel} ${hours} ${hLabel}`;
  if (days > 0) return `${days} ${dLabel}`;
  return `${hours} ${hLabel}`;
};

export const formatDurationFromSec = (
  totalSeconds: number | null | undefined,
): string => {
  if (totalSeconds == null) return "-";
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return [
    String(days).padStart(2, "0"),
    String(hours).padStart(2, "0"),
    String(minutes).padStart(2, "0"),
    String(seconds).padStart(2, "0"),
  ].join(":");
};

export const getPriorityTranslationKey = (priority?: string | null): string => {
  switch (priority) {
    case "0":
      return "request.priority.low";
    case "1":
      return "request.priority.medium";
    case "2":
      return "request.priority.high";
    case "3":
      return "request.priority.urgent";
    default:
      return "request.priority.low";
  }
};
